import { z } from 'zod';

export const billingEmailSchema = z.object({
  email: z
    .string()
    .trim()
    .pipe(z.email({ error: 'Enter a full address, like billing@company.com.' })),
});

export type BillingEmailValues = z.infer<typeof billingEmailSchema>;

export const BILLING_EMAIL_DEFAULTS: BillingEmailValues = { email: '' };
